import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { getDefaultAssignee } from '../../../../state/components/selectors.tsx';
import type { State } from '../../../../state/reducer.tsx';
import DefaultAssigneeView from './view.tsx';

type Props = {
	componentId: string;
};

const mapStateToProps = (state: State, ownProps: Props) => ({
	defaultAssignee: getDefaultAssignee(state, ownProps.componentId),
});

export default connect(mapStateToProps, {})(DefaultAssigneeView);
